import axios from "axios";

const API = axios.create({
  baseURL: "https://api.ilogically.com/api/notification"
});

// LIST
export const getAutomations = () =>
  API.get("/triggers");

// GET ONE
export const getAutomationById = (id) =>
  API.get(`/triggers/${id}`);

// CREATE
export const createAutomation = (payload) =>
  API.post("/triggers", payload);

// UPDATE
export const updateAutomation = (id, payload) =>
  API.put(`/triggers/${id}`, payload);

// DELETE
export const deleteAutomation = (id) =>
  API.delete(`/triggers/${id}`);

// TOGGLE
export const toggleAutomation = (id, isActive) =>
  API.patch(`/triggers/${id}/toggle`, { isActive });
